import { useMutation } from "@apollo/client";

import { SettingsResearchTypeEditRoute_DeleteDocument } from "../mutations.generated";
import { SettingsResearchTypeEditRoute_GetByIdDocument } from "../queries.generated";

export default function useSettingsResearchTypeEditRoute_Delete() {
    const [mutate, { loading, error }] = useMutation(SettingsResearchTypeEditRoute_DeleteDocument, {
        refetchQueries: [SettingsResearchTypeEditRoute_GetByIdDocument],
    });

    const deleteResearchType = async (researchTypeId: string): Promise<void> => {
        mutate({ variables: { input: { researchTypeId } } });
    };

    return {
        deleteResearchType,
        loading,
        error,
    };
}
